import interact from "interactjs";
import Swal from "sweetalert2";

// SPM-374 floor plan editor (3-column). Placement = creation for tables and
// fixtures; the right panel edits the selected object (name, colors, icon,
// icon size, image upload, rotation) and everything autosaves.
//
// Canvas visuals are DATA-DRIVEN: each element carries data-* attributes and
// `applyTableVisual` / `applyFixtureVisual` build the inner DOM from them, so
// server-rendered (on load) and JS-created (on placement) elements share one
// renderer.
$(document).on("turbolinks:load", function () {
  if (!$(".fp-editor").length) return;

  // Turbolinks fires turbolinks:load on every navigation; clear any handlers
  // from a previous visit so clicks don't fire twice (double-create bug).
  // $(document).off also clears the delegated jQuery handlers; interact keeps
  // its own cached listeners per selector, so unset them too or "tap" (select)
  // fires once per prior visit.
  $(document).off(".fp");
  interact(".table-dragable").unset();
  interact(".fp-fixture").unset();

  var GRID = 24;
  var $grid = $(".fp-grid");
  var floorId = $grid.data("floor-id");
  var ICON_OPTIONS = $grid.data("icon-options") || {};
  var selected = null; // { type: "table" | "fixture", el: DOMElement }
  var snapEnabled = true;
  var zoom = 1;

  function csrf() { return $('meta[name="csrf-token"]').attr("content"); }

  // Lay out new objects in a grid so they don't stack on the same spot.
  // Monotonic counter (seeded from what's already on the canvas) — it never
  // decreases when objects are deleted, so new drops keep finding fresh slots.
  var dropCounter = $(".dragable-panel").children(".table-dragable, .fp-fixture").length;
  function nextDropPos() {
    var n = dropCounter++;
    var stepX = 96, stepY = 96, cols = 6, rows = 5;
    return {
      x: GRID + (n % cols) * stepX,
      y: GRID + (Math.floor(n / cols) % rows) * stepY,
    };
  }
  function escapeHtml(s) { return $("<div>").text(s == null ? "" : s).html(); }
  function iconBasedType(ftype) { return Object.prototype.hasOwnProperty.call(ICON_OPTIONS, ftype); }

  // ---- save-state indicator ----
  function setSaved(state) {
    var $ind = $("#fp-saved-indicator").removeClass("saving unsaved");
    if (state === "saving") $ind.addClass("saving").text("Saving…");
    else if (state === "unsaved") $ind.addClass("unsaved").text("Unsaved changes");
    else $ind.text("All changes saved");
  }

  function updateSeats() {
    var total = 0;
    $(".dragable-panel .table-dragable").each(function () {
      total += parseInt($(this).attr("data-capacity"), 10) || 0;
    });
    $("#fp-seats-total").text("Seats: " + total);
  }

  // ---- data-driven canvas rendering ----
  function applyTableVisual(el) {
    var $el = $(el);
    el.style.borderRadius = $el.attr("data-shape") === "circle"
      ? "50%" : ((parseInt($el.attr("data-border-radius"), 10) || 0) + "px");
    var img = $el.attr("data-image-url");
    if (img) {
      if ($el.find(".table-img").length) $el.find(".table-img").attr("src", img);
      else $el.prepend('<img class="table-img" src="' + img + '">');
      el.style.backgroundColor = "";
    } else {
      $el.find(".table-img").remove();
      el.style.backgroundColor = $el.attr("data-color") || "";
    }
  }

  function applyFixtureVisual(el) {
    var $el = $(el);
    var ftype = $el.attr("data-fixture-type");
    var img = $el.attr("data-image-url");
    var bg = $el.attr("data-bg-color");
    var name = $el.attr("data-name");
    var pos = $el.attr("data-name-position") || "bottom";
    var iconBased = iconBasedType(ftype);
    var html = "";

    el.style.borderRadius = ftype === "plant"
      ? "50%" : ((parseInt($el.attr("data-border-radius"), 10) || 0) + "px");
    el.style.backgroundColor = (!img && bg) ? bg : "";

    if (img) {
      html += '<img class="fixture-img" src="' + img + '">';
    } else if (iconBased) {
      var icon = $el.attr("data-icon") || (ICON_OPTIONS[ftype] || [])[0] || "";
      var size = parseInt($el.attr("data-icon-size"), 10) || 20;
      var color = $el.attr("data-icon-color") || "";
      html += '<i class="fas fa-' + icon + '" style="font-size:' + size + "px;color:" + color + '"></i>';
    } else {
      var label = name || (ftype === "divider" ? "" : (ftype === "podium" ? "host" : ftype));
      html += '<span class="fixture-body-label">' + escapeHtml(label) + "</span>";
    }
    // name label around icon/image (text fixtures already show it centered)
    if (name && (img || iconBased)) {
      html += '<span class="fixture-name pos-' + pos + '">' + escapeHtml(name) + "</span>";
    }
    $el.html(html);
  }

  // ---- rotate handle ----
  var ROTATE_HANDLE_HTML = '<div class="fp-rotate-handle" title="Drag to rotate"><i class="fas fa-sync-alt"></i></div>';

  function attachRotateHandle(el) {
    $(el).find(".fp-rotate-handle").remove();
    var $handle = $(ROTATE_HANDLE_HTML).appendTo(el);

    var startAngle = null;
    var startRot = null;

    function getAngle(cx, cy, ex, ey) {
      return Math.atan2(ey - cy, ex - cx) * (180 / Math.PI);
    }

    function onMouseMove(e) {
      var rect = el.getBoundingClientRect();
      var cx = rect.left + rect.width / 2;
      var cy = rect.top + rect.height / 2;
      var currentAngle = getAngle(cx, cy, e.clientX, e.clientY);
      var delta = currentAngle - startAngle;
      var rot = ((startRot + delta) % 360 + 360) % 360;
      el.setAttribute("data-rotation", Math.round(rot));
      el.style.transform = "rotate(" + rot + "deg)";
    }

    function onMouseUp() {
      $(document).off("mousemove.fprot mouseup.fprot");
      if (selected && selected.el === el) {
        if (selected.type === "table") {
          saveTablePosition(el);
        } else {
          saveFixturePosition(el);
        }
      }
    }

    $handle.on("mousedown", function (e) {
      e.preventDefault();
      e.stopPropagation();
      var rect = el.getBoundingClientRect();
      var cx = rect.left + rect.width / 2;
      var cy = rect.top + rect.height / 2;
      startAngle = getAngle(cx, cy, e.clientX, e.clientY);
      startRot = parseInt(el.getAttribute("data-rotation"), 10) || 0;
      $(document).on("mousemove.fprot", onMouseMove).on("mouseup.fprot", onMouseUp);
    });
  }

  // ---- selection / right panel ----
  function deselectAll() {
    $(".table-dragable, .fp-fixture").removeClass("selected");
    $(".fp-rotate-handle").remove();
    selected = null;
    $("#fp-panel-empty").removeClass("hidden");
    $(".fp-fields").removeClass("active");
  }

  // app-style dropzone: show saved thumbnail or the "+ Browse Files" prompt
  function setDropzoneState(zoneSel, url) {
    var $z = $(zoneSel);
    $z.find(".fp-dz-file").val("");
    if (url) {
      $z.find(".fp-dz-thumb").attr("src", url).show();
      $z.find(".fp-dz-empty").hide();
      $z.find(".fp-dz-remove").show();
    } else {
      $z.find(".fp-dz-thumb").hide().attr("src", "");
      $z.find(".fp-dz-empty").show();
      $z.find(".fp-dz-remove").hide();
    }
  }

  function selectTable(el) {
    deselectAll();
    var $el = $(el).addClass("selected");
    selected = { type: "table", el: el };
    $("#fp-panel-empty").addClass("hidden");
    $("#fp-fixture-fields").removeClass("active");
    $("#fp-table-fields").addClass("active");
    $("#fp-table-no").val($el.attr("data-table-no"));
    $("#fp-table-display-name").val($el.find(".table-label").text().trim());
    $("#fp-table-capacity").val($el.attr("data-capacity"));
    $("#fp-table-menu-category").val($el.attr("data-menu-category-id") || "");
    $("#fp-table-revenue-center").val($el.attr("data-revenue-center-id") || "");
    $("#fp-table-width").val(parseInt(el.style.width, 10));
    $("#fp-table-height").val(parseInt(el.style.height, 10));
    $("#fp-table-x").val(parseInt(el.style.left, 10) || 0);
    $("#fp-table-y").val(parseInt(el.style.top, 10) || 0);
    $("#fp-table-color").val($el.attr("data-color") || "#34c98b");
    $("#fp-table-radius").val(parseInt($el.attr("data-border-radius"), 10) || 0);
    $("#fp-table-available").prop("checked", $el.attr("data-available") !== "false");
    setDropzoneState("#fp-table-dropzone", $el.attr("data-image-url"));
    attachRotateHandle(el);
  }

  function buildIconChoices(ftype, current) {
    var $wrap = $("#fp-fixture-icon-choices").empty();
    (ICON_OPTIONS[ftype] || []).forEach(function (ic) {
      var $c = $('<div class="fp-icon-choice" data-icon="' + ic + '"><i class="fas fa-' + ic + '"></i></div>');
      if (ic === current) $c.addClass("active");
      $wrap.append($c);
    });
  }

  function selectFixture(el) {
    deselectAll();
    var $el = $(el).addClass("selected");
    selected = { type: "fixture", el: el };
    var ftype = $el.attr("data-fixture-type");
    var iconBased = iconBasedType(ftype);
    $("#fp-panel-empty").addClass("hidden");
    $("#fp-table-fields").removeClass("active");
    $("#fp-fixture-fields").addClass("active");
    $("#fp-fixture-type").val(ftype === "podium" ? "host" : ftype);
    $("#fp-fixture-name").val($el.attr("data-name") || "");
    $("#fp-fixture-name-position").val($el.attr("data-name-position") || "bottom");
    $("#fp-fixture-width").val(parseInt(el.style.width, 10));
    $("#fp-fixture-height").val(parseInt(el.style.height, 10));
    $("#fp-fixture-x").val(parseInt(el.style.left, 10) || 0);
    $("#fp-fixture-y").val(parseInt(el.style.top, 10) || 0);
    $("#fp-fixture-bg-color").val($el.attr("data-bg-color") || "#d7dbe0");
    $("#fp-fixture-icon-color").val($el.attr("data-icon-color") || "#2e9e5b");
    $("#fp-fixture-icon-size").val(parseInt($el.attr("data-icon-size"), 10) || 20);
    $("#fp-fixture-radius").val(parseInt($el.attr("data-border-radius"), 10) || 0);
    buildIconChoices(ftype, $el.attr("data-icon"));
    $(".fp-icon-only").toggle(iconBased);
    $(".fp-image-only").toggle(!iconBased);
    setDropzoneState("#fp-fixture-dropzone", $el.attr("data-image-url"));
    attachRotateHandle(el);
  }

  // ---- geometry helpers ----
  function snap(el) {
    if (!snapEnabled) return;
    el.style.left = Math.round((parseFloat(el.style.left) || 0) / GRID) * GRID + "px";
    el.style.top = Math.round((parseFloat(el.style.top) || 0) / GRID) * GRID + "px";
  }

  function applyRotation(el) {
    var rot = parseInt(el.getAttribute("data-rotation"), 10) || 0;
    el.style.transform = "rotate(" + rot + "deg)";
  }

  function dragMove(event) {
    var t = event.target;
    t.style.left = (parseFloat(t.style.left) || 0) + event.dx / zoom + "px";
    t.style.top = (parseFloat(t.style.top) || 0) + event.dy / zoom + "px";
    if (selected && selected.el === t) {
      var pfx = selected.type === "table" ? "#fp-table-" : "#fp-fixture-";
      $(pfx + "x").val(parseInt(t.style.left, 10));
      $(pfx + "y").val(parseInt(t.style.top, 10));
    }
  }

  function resizeMove(event) {
    var t = event.target;
    t.style.width = event.rect.width / zoom + "px";
    t.style.height = event.rect.height / zoom + "px";
    t.style.left = (parseFloat(t.style.left) || 0) + event.deltaRect.left / zoom + "px";
    t.style.top = (parseFloat(t.style.top) || 0) + event.deltaRect.top / zoom + "px";
    if (selected && selected.el === t) {
      var wid = parseInt(t.style.width, 10), hei = parseInt(t.style.height, 10);
      $(selected.type === "table" ? "#fp-table-width" : "#fp-fixture-width").val(wid);
      $(selected.type === "table" ? "#fp-table-height" : "#fp-fixture-height").val(hei);
    }
  }

  // ---- persistence (tables) ----
  function saveTablePosition(el) {
    var $el = $(el);
    setSaved("saving");
    $.ajax({
      method: "POST",
      url: "/product_layouts/floors/" + floorId + "/save_table_position",
      data: {
        table_id: $el.attr("data-table-id"),
        x: parseInt(el.style.left, 10) || 0,
        y: parseInt(el.style.top, 10) || 0,
        width: parseInt(el.style.width, 10),
        height: parseInt(el.style.height, 10),
        rotation: parseInt(el.getAttribute("data-rotation"), 10) || 0,
      },
    }).done(function () { setSaved("saved"); }).fail(function () { setSaved("unsaved"); });
  }

  function tableUrl($el) { return "/product_layouts/tables/" + $el.attr("data-table-id"); }

  function saveTableAttrs() {
    if (!selected || selected.type !== "table") return;
    var el = selected.el, $el = $(el);
    setSaved("saving");
    $.ajax({
      method: "PATCH",
      url: tableUrl($el),
      data: {
        resp_type: "json",
        table: {
          table_no: $("#fp-table-no").val(),
          display_name: $("#fp-table-display-name").val(),
          capacity: $("#fp-table-capacity").val(),
          menu_category_id: $("#fp-table-menu-category").val(),
          revenue_center_id: $("#fp-table-revenue-center").val(),
          is_available: $("#fp-table-available").prop("checked"),
          color: $("#fp-table-color").val(),
          border_radius: $("#fp-table-radius").val(),
          width: $("#fp-table-width").val(),
          height: $("#fp-table-height").val(),
        },
      },
    }).done(function (data) {
      $el.find(".table-label").text(data.display_name);
      $el.attr("data-table-no", data.table_no);
      $el.attr("data-capacity", data.capacity);
      $el.attr("data-menu-category-id", data.menu_category_id || "");
      $el.attr("data-revenue-center-id", data.revenue_center_id || "");
      $el.attr("data-available", data.is_available);
      $el.attr("data-color", data.color || "");
      $el.attr("data-border-radius", data.border_radius);
      el.style.width = data.width + "px";
      el.style.height = data.height + "px";
      applyTableVisual(el);
      updateSeats();
      setSaved("saved");
    }).fail(function () { setSaved("unsaved"); });
  }

  // ---- persistence (fixtures) ----
  function fixtureUrl($el) {
    return "/product_layouts/floors/" + floorId + "/floor_fixtures/" + $el.attr("data-fixture-id");
  }

  function fixtureAttrPayload($el) {
    return {
      name: $el.attr("data-name") || "",
      name_position: $el.attr("data-name-position") || "bottom",
      bg_color: $el.attr("data-bg-color") || "",
      icon: $el.attr("data-icon") || "",
      icon_color: $el.attr("data-icon-color") || "",
      icon_size: parseInt($el.attr("data-icon-size"), 10) || 20,
      border_radius: parseInt($el.attr("data-border-radius"), 10) || 0,
      width: parseInt($el[0].style.width, 10),
      height: parseInt($el[0].style.height, 10),
    };
  }

  function saveFixturePosition(el) {
    var $el = $(el);
    setSaved("saving");
    $.ajax({
      method: "POST",
      url: fixtureUrl($el) + "/save_position",
      data: {
        floor_fixture: {
          x: parseInt(el.style.left, 10) || 0,
          y: parseInt(el.style.top, 10) || 0,
          width: parseInt(el.style.width, 10),
          height: parseInt(el.style.height, 10),
          rotation: parseInt(el.getAttribute("data-rotation"), 10) || 0,
        },
      },
    }).done(function () { setSaved("saved"); }).fail(function () { setSaved("unsaved"); });
  }

  function saveFixtureAttrs() {
    if (!selected || selected.type !== "fixture") return;
    var $el = $(selected.el);
    setSaved("saving");
    $.ajax({
      method: "PATCH",
      url: fixtureUrl($el),
      data: { floor_fixture: fixtureAttrPayload($el) },
    }).done(function () { setSaved("saved"); }).fail(function () { setSaved("unsaved"); });
  }

  // set a fixture data-* attr from the panel, live-render, then persist
  function setFixtureAttr(attr, val) {
    if (!selected || selected.type !== "fixture") return;
    $(selected.el).attr(attr, val);
    applyFixtureVisual(selected.el);
    saveFixtureAttrs();
  }

  // ---- shared image upload ----
  function uploadImage(url, formData, onDone) {
    setSaved("saving");
    formData.append("resp_type", "json");
    $.ajax({
      method: "POST", // Rails treats _method override; use PATCH via header
      url: url,
      data: formData,
      processData: false,
      contentType: false,
      headers: { "X-CSRF-Token": csrf(), "X-HTTP-Method-Override": "PATCH" },
    }).done(function (d) { onDone(d); setSaved("saved"); }).fail(function () { setSaved("unsaved"); });
  }

  // ---- placement = creation (tables) ----
  $(document).on("click.fp", ".js-add-table", function () {
    var shape = $(this).attr("data-shape");
    var color = $(this).attr("data-seating") === "bar" ? "#a78bfa" : "#34c98b";
    var pos = nextDropPos();
    setSaved("saving");
    $.ajax({
      method: "POST",
      url: "/product_layouts/tables",
      data: {
        resp_type: "json",
        table: { shape: shape, color: color, floor_id: floorId, x: pos.x, y: pos.y, width: 60, height: 60 },
      },
    }).done(function (data) {
      if (data.error) { setSaved("unsaved"); alert(data.error); return; }
      var cls = shape === "circle" ? "circle" : "square";
      var $t = $('<div class="table-dragable ' + cls + '"><span class="table-label"></span></div>');
      $t.attr({
        id: data.id, "data-shape": shape, "data-color": color, "data-table-id": data.id,
        "data-table-no": data.table_no, "data-floor-id": floorId, "data-capacity": data.capacity, "data-rotation": 0,
        "data-menu-category-id": data.menu_category_id || "", "data-available": true,
        "data-border-radius": data.border_radius, "data-image-url": "",
      });
      $t.css({ top: pos.y + "px", left: pos.x + "px", width: "60px", height: "60px" });
      $t.find(".table-label").text(data.display_name);
      $(".dragable-panel").append($t);
      applyTableVisual($t[0]);
      updateSeats();
      setSaved("saved");
      selectTable($t[0]);
    }).fail(function () { setSaved("unsaved"); });
  });

  // default footprint per fixture type when first dropped
  var FIXTURE_SIZE = {
    divider: { w: 10, h: 100 },
    plant: { w: 45, h: 45 },
    door: { w: 50, h: 50 },
  };
  function fixtureSize(ftype) { return FIXTURE_SIZE[ftype] || { w: 80, h: 40 }; }

  // ---- placement = creation (fixtures) ----
  $(document).on("click.fp", ".js-add-fixture", function () {
    var ftype = $(this).attr("data-fixture-type");
    var size = fixtureSize(ftype);
    var pos = nextDropPos();
    setSaved("saving");
    $.ajax({
      method: "POST",
      url: "/product_layouts/floors/" + floorId + "/floor_fixtures",
      data: { floor_fixture: { fixture_type: ftype, x: pos.x, y: pos.y, width: size.w, height: size.h, rotation: 0 } },
    }).done(function (data) {
      var $f = $('<div class="fp-fixture fixture-' + ftype + '"></div>');
      $f.attr({
        id: "fixture-" + data.id, "data-fixture-id": data.id, "data-fixture-type": ftype,
        "data-floor-id": floorId, "data-rotation": 0, "data-name": data.name || "",
        "data-icon": data.icon || "", "data-icon-size": data.icon_size || 20,
        "data-icon-color": data.icon_color || "", "data-bg-color": data.bg_color || "",
        "data-name-position": data.name_position || "bottom",
        "data-border-radius": data.border_radius, "data-image-url": data.image_url || "",
      });
      $f.css({ top: pos.y + "px", left: pos.x + "px", width: size.w + "px", height: size.h + "px" });
      $(".dragable-panel").append($f);
      applyFixtureVisual($f[0]);
      setSaved("saved");
      selectFixture($f[0]);
    }).fail(function () { setSaved("unsaved"); });
  });

  // ---- right-panel edits (tables) ----
  $(document).on("change.fp", "#fp-table-no, #fp-table-display-name, #fp-table-capacity, #fp-table-menu-category, #fp-table-revenue-center, #fp-table-available, #fp-table-color, #fp-table-radius, #fp-table-width, #fp-table-height", saveTableAttrs);

  // Optional exact X/Y — move the selected element and persist its position.
  $(document).on("change.fp", "#fp-table-x, #fp-table-y", function () {
    if (!selected || selected.type !== "table") return;
    var el = selected.el;
    el.style.left = (parseInt($("#fp-table-x").val(), 10) || 0) + "px";
    el.style.top = (parseInt($("#fp-table-y").val(), 10) || 0) + "px";
    saveTablePosition(el);
  });

  function uploadTableImage(file) {
    if (!selected || selected.type !== "table") return;
    var fd = new FormData();
    fd.append("table[image]", file);
    var $el = $(selected.el);
    uploadImage(tableUrl($el), fd, function (d) {
      $el.attr("data-image-url", d.image_url || "");
      applyTableVisual($el[0]);
      setDropzoneState("#fp-table-dropzone", d.image_url);
    });
  }

  function removeTableImage() {
    if (!selected || selected.type !== "table") return;
    var $el = $(selected.el);
    setSaved("saving");
    $.ajax({
      method: "PATCH", url: tableUrl($el),
      data: { resp_type: "json", remove_image: 1, table: { display_name: $("#fp-table-display-name").val() } },
    }).done(function () {
      $el.attr("data-image-url", "");
      applyTableVisual($el[0]);
      setDropzoneState("#fp-table-dropzone", "");
      setSaved("saved");
    }).fail(function () { setSaved("unsaved"); });
  }

  $(document).on("click.fp", "#fp-table-rotate", function () {
    if (!selected || selected.type !== "table") return;
    var el = selected.el;
    var rot = ((parseInt(el.getAttribute("data-rotation"), 10) || 0) + 90) % 360;
    el.setAttribute("data-rotation", rot);
    applyRotation(el);
    saveTablePosition(el);
  });

  $(document).on("click.fp", "#fp-table-delete", function () {
    if (!selected || selected.type !== "table") return;
    var el = selected.el, id = $(el).attr("data-table-id");
    Swal.fire({
      title: "Remove table from floor?",
      text: "The table is kept and becomes an unplaced table — it is not deleted.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, remove",
      cancelButtonText: "Cancel",
    }).then(function (result) {
      if (!result.value) return;
      setSaved("saving");
      // Detach only — the table record is kept and becomes unplaced/available.
      $.ajax({
        method: "DELETE",
        url: "/product_layouts/floors/" + floorId + "/remove_table_postion",
        data: { table_id: id, resp_type: "json" },
        headers: { "X-CSRF-Token": csrf() },
      }).done(function () {
        $(el).remove();
        deselectAll();
        updateSeats();
        setSaved("saved");
      }).fail(function (xhr) {
        setSaved("unsaved");
        var msg = (xhr.responseJSON && xhr.responseJSON.message) ||
          "Could not remove the table. Please try again.";
        Swal.fire({ title: "Can't remove table", text: msg, icon: "error" });
      });
    });
  });

  // ---- right-panel edits (fixtures) ----
  $(document).on("change.fp", "#fp-fixture-name", function () { setFixtureAttr("data-name", $(this).val()); });
  $(document).on("change.fp", "#fp-fixture-name-position", function () { setFixtureAttr("data-name-position", $(this).val()); });
  $(document).on("change.fp", "#fp-fixture-bg-color", function () { setFixtureAttr("data-bg-color", $(this).val()); });
  $(document).on("change.fp", "#fp-fixture-icon-color", function () { setFixtureAttr("data-icon-color", $(this).val()); });
  $(document).on("change.fp", "#fp-fixture-icon-size", function () { setFixtureAttr("data-icon-size", $(this).val()); });
  $(document).on("change.fp", "#fp-fixture-radius", function () { setFixtureAttr("data-border-radius", $(this).val()); });

  // Optional exact X/Y for fixtures.
  $(document).on("change.fp", "#fp-fixture-x, #fp-fixture-y", function () {
    if (!selected || selected.type !== "fixture") return;
    var el = selected.el;
    el.style.left = (parseInt($("#fp-fixture-x").val(), 10) || 0) + "px";
    el.style.top = (parseInt($("#fp-fixture-y").val(), 10) || 0) + "px";
    saveFixturePosition(el);
  });

  // Live preview while dragging color pickers / sliders (persist on "change").
  function liveTableAttr(attr, val) {
    if (!selected || selected.type !== "table") return;
    $(selected.el).attr(attr, val);
    applyTableVisual(selected.el);
  }
  function liveFixtureAttr(attr, val) {
    if (!selected || selected.type !== "fixture") return;
    $(selected.el).attr(attr, val);
    applyFixtureVisual(selected.el);
  }
  $(document).on("input.fp", "#fp-table-color", function () { liveTableAttr("data-color", $(this).val()); });
  $(document).on("input.fp", "#fp-table-radius", function () { liveTableAttr("data-border-radius", $(this).val()); });
  $(document).on("input.fp", "#fp-fixture-bg-color", function () { liveFixtureAttr("data-bg-color", $(this).val()); });
  $(document).on("input.fp", "#fp-fixture-icon-color", function () { liveFixtureAttr("data-icon-color", $(this).val()); });
  $(document).on("input.fp", "#fp-fixture-icon-size", function () { liveFixtureAttr("data-icon-size", $(this).val()); });
  $(document).on("input.fp", "#fp-fixture-radius", function () { liveFixtureAttr("data-border-radius", $(this).val()); });
  $(document).on("change.fp", "#fp-fixture-width, #fp-fixture-height", function () {
    if (!selected || selected.type !== "fixture") return;
    selected.el.style.width = $("#fp-fixture-width").val() + "px";
    selected.el.style.height = $("#fp-fixture-height").val() + "px";
    saveFixtureAttrs();
  });

  $(document).on("click.fp", ".fp-icon-choice", function () {
    $("#fp-fixture-icon-choices .fp-icon-choice").removeClass("active");
    $(this).addClass("active");
    setFixtureAttr("data-icon", $(this).attr("data-icon"));
  });

  function uploadFixtureImage(file) {
    if (!selected || selected.type !== "fixture") return;
    var fd = new FormData();
    fd.append("floor_fixture[image]", file);
    var $el = $(selected.el);
    uploadImage(fixtureUrl($el), fd, function (d) {
      $el.attr("data-image-url", d.image_url || "");
      applyFixtureVisual($el[0]);
      setDropzoneState("#fp-fixture-dropzone", d.image_url);
    });
  }

  function removeFixtureImage() {
    if (!selected || selected.type !== "fixture") return;
    var $el = $(selected.el);
    setSaved("saving");
    $.ajax({
      method: "PATCH", url: fixtureUrl($el),
      data: { remove_image: 1, floor_fixture: fixtureAttrPayload($el) },
    }).done(function () {
      $el.attr("data-image-url", "");
      applyFixtureVisual($el[0]);
      setDropzoneState("#fp-fixture-dropzone", "");
      setSaved("saved");
    }).fail(function () { setSaved("unsaved"); });
  }

  // ---- dropzone wiring (click / drag-drop / remove) ----
  function wireDropzone(zoneSel, onUpload, onRemove) {
    $(document).on("click.fp", zoneSel, function (e) {
      if ($(e.target).closest(".fp-dz-remove").length) return;
      $(zoneSel + " .fp-dz-file")[0].click();
    });
    $(document).on("change.fp", zoneSel + " .fp-dz-file", function () {
      var f = this.files[0];
      if (f) onUpload(f);
    });
    $(document).on("dragover.fp", zoneSel, function (e) { e.preventDefault(); $(this).addClass("dragover"); });
    $(document).on("dragleave.fp", zoneSel, function () { $(this).removeClass("dragover"); });
    $(document).on("drop.fp", zoneSel, function (e) {
      e.preventDefault();
      $(this).removeClass("dragover");
      var f = e.originalEvent.dataTransfer.files[0];
      if (f) onUpload(f);
    });
    $(document).on("click.fp", zoneSel + " .fp-dz-remove", function (e) {
      e.stopPropagation();
      onRemove();
    });
  }
  wireDropzone("#fp-table-dropzone", uploadTableImage, removeTableImage);
  wireDropzone("#fp-fixture-dropzone", uploadFixtureImage, removeFixtureImage);

  function rotateFixture(step) {
    if (!selected || selected.type !== "fixture") return;
    var el = selected.el;
    var rot = ((parseInt(el.getAttribute("data-rotation"), 10) || 0) + step) % 360;
    el.setAttribute("data-rotation", rot);
    applyRotation(el);
    saveFixturePosition(el);
  }
  $(document).on("click.fp", "#fp-fixture-rotate", function () { rotateFixture(90); });
  $(document).on("click.fp", "#fp-fixture-rotate-180", function () { rotateFixture(180); });

  $(document).on("click.fp", "#fp-fixture-delete", function () {
    if (!selected || selected.type !== "fixture") return;
    var el = selected.el, id = $(el).attr("data-fixture-id");
    Swal.fire({
      title: "Delete this fixture?",
      text: "This will remove the fixture from the floor.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete",
      cancelButtonText: "Cancel",
    }).then(function (result) {
      if (!result.value) return;
      setSaved("saving");
      $.ajax({
        method: "DELETE",
        url: "/product_layouts/floors/" + floorId + "/floor_fixtures/" + id + "/remove",
      }).done(function () {
        $(el).remove();
        deselectAll();
        setSaved("saved");
      }).fail(function () { setSaved("unsaved"); });
    });
  });

  // ---- interact: drag / resize / select ----
  interact(".table-dragable")
    .draggable({
      ignoreFrom: ".fp-rotate-handle",
      listeners: { move: dragMove, end: function (e) { snap(e.target); saveTablePosition(e.target); } },
      modifiers: [interact.modifiers.restrictRect({ restriction: "parent", endOnly: true })],
      inertia: false,
    })
    .resizable({
      ignoreFrom: ".fp-rotate-handle",
      edges: { left: true, right: true, bottom: true, top: true },
      listeners: { move: resizeMove, end: function (e) { snap(e.target); saveTablePosition(e.target); } },
      modifiers: [interact.modifiers.restrictSize({ min: { width: 30, height: 30 } })],
    })
    .on("tap", function (e) { selectTable(e.currentTarget); });

  interact(".fp-fixture")
    .draggable({
      ignoreFrom: ".fp-rotate-handle",
      listeners: { move: dragMove, end: function (e) { snap(e.target); saveFixturePosition(e.target); } },
      modifiers: [interact.modifiers.restrictRect({ restriction: "parent", endOnly: true })],
      inertia: false,
    })
    .resizable({
      ignoreFrom: ".fp-rotate-handle",
      edges: { left: true, right: true, bottom: true, top: true },
      listeners: { move: resizeMove, end: function (e) { snap(e.target); saveFixturePosition(e.target); } },
      modifiers: [interact.modifiers.restrictSize({ min: { width: 20, height: 20 } })],
    })
    .on("tap", function (e) { selectFixture(e.currentTarget); });

  // ---- deselect on empty canvas ----
  $(document).on("click.fp", ".dragable-panel", function (e) {
    if (e.target === this) deselectAll();
  });

  // ---- Delete / Backspace removes the selected object (opens the popup) ----
  $(document).on("keydown.fp", function (e) {
    if (e.key !== "Delete" && e.key !== "Backspace") return;
    if (!selected) return;
    var tag = (e.target.tagName || "").toLowerCase();
    if (tag === "input" || tag === "textarea" || tag === "select" || e.target.isContentEditable) return;
    e.preventDefault();
    $(selected.type === "table" ? "#fp-table-delete" : "#fp-fixture-delete").click();
  });

  // ---- snap toggle + zoom ----
  $(document).on("change.fp", "#fp-snap-toggle", function () { snapEnabled = $(this).prop("checked"); });

  function applyZoom() {
    $(".dragable-panel").css("transform", "scale(" + zoom + ")");
    $("#fp-zoom-level").text(Math.round(zoom * 100) + "%");
  }
  $(document).on("click.fp", "#fp-zoom-in", function () {
    zoom = Math.min(1.5, Math.round((zoom + 0.1) * 10) / 10);
    applyZoom();
  });
  $(document).on("click.fp", "#fp-zoom-out", function () {
    zoom = Math.max(0.5, Math.round((zoom - 0.1) * 10) / 10);
    applyZoom();
  });

  // ---- initial render of server-provided elements ----
  $(".dragable-panel .table-dragable").each(function () { applyTableVisual(this); });
  $(".dragable-panel .fp-fixture").each(function () { applyFixtureVisual(this); });
  updateSeats();
});
